import React, { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";

import AuthService from "../../services/auth.service";
import instance from "../../services/ApiServices";
import { useSelector } from "react-redux";
import UserService from "../../services/UserService";
import ShippingAddress from "../shippingaddress/ShippingAddress";

function Profile() {
  const user = useSelector((store) => store.user);
  const [profile, setProfile] = useState([]);

  const retrieveUser = () => {
    UserService.getuser(user.token)
      .then((response) => {
        setProfile(response.data.user);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  useEffect(() => {
    retrieveUser();
  }, []);

  console.log(profile);

  return (
    <div className="container p-12">
      <div>
        <header className="jumbotron">
          <h3>
            <strong>{profile.name} ! Profile</strong>
          </h3>
        </header>
        <p></p>
        <p>
          <strong>Id:{profile.id}</strong>
        </p>
        <p>
          <strong>Email:{profile.email}</strong>
        </p>
      </div>
    </div>
  );
}

export default Profile;
